module.exports = __webpack_public_path__ + "img/es-pc-s5.c0cdf90f.png";